import { IState } from '../../../../../store/types';
import { connect } from 'react-redux';
import { ITranslateTabEvents, ITranslateTabFields } from '../components/types';
import { TranslateTab } from '../components/TranslateTab';
import { getAuthUserTranslateLangs } from '../../../../../store/general/selectors';
import { PhraseDetailsSelectors } from '../../../../../store/phrase-details/selectors';

const mapStateToProps = (
	dispatch: any
) => {
	return (
		state: IState,
	): ITranslateTabFields => {

		const userTranslateLangs = getAuthUserTranslateLangs(state);
		const toLang = PhraseDetailsSelectors.getToLang(state);
		let translateLangs: string[] = toLang ? [toLang.code] : [];
		if (userTranslateLangs?.length) {
			userTranslateLangs.forEach(lang => {
				const exists = translateLangs.find(l => l === lang.code);
				if (!exists) translateLangs.push(lang.code);
			})
		}

		return {
			translateLangs,
		}
	};
}

const mapDispatchToProps = (
	dispatch: any,
): ITranslateTabEvents => {
	return {
	}
}

export const TranslateTabHOC = connect(
	mapStateToProps,
	null,
)(TranslateTab) as any;

TranslateTabHOC.displayName = 'TranslateTabHOC';
